import React, { useEffect, useState } from "react";
import { requestMagicLink } from "../api";

const JWT_KEY = "magic-link-jwt";
const AUTH_CHANGED_EVENT = "auth-changed";

function getEmailFromJwt(jwt: string): string | null {
  try {
    const payload = JSON.parse(atob(jwt.split(".")[1]));
    return payload.email ?? null;
  } catch {
    return null;
  }
}

const LoginButton: React.FC = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState<"idle" | "input" | "sent">("idle");
  const [error, setError] = useState("");
  const [loggedInEmail, setLoggedInEmail] = useState<string | null>(() => {
    const jwt = localStorage.getItem(JWT_KEY);
    return jwt ? getEmailFromJwt(jwt) : null;
  });

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === JWT_KEY) {
        setLoggedInEmail(e.newValue ? getEmailFromJwt(e.newValue) : null);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem(JWT_KEY);
    setLoggedInEmail(null);
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
  };

  const handleRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await requestMagicLink(email);
      setStep("sent");
    } catch {
      setError("Något gick fel. Försök igen.");
    }
  };

  if (loggedInEmail) {
    return (
      <div className="login-widget">
        <span className="login-email">Inloggad med {loggedInEmail}</span>
        <button className="login-btn login-btn--out" onClick={handleLogout}>
          Logga ut
        </button>
      </div>
    );
  }

  if (step === "idle") {
    return (
      <div className="login-widget">
        <button className="login-btn" onClick={() => setStep("input")}>
          Logga in
        </button>
      </div>
    );
  }

  if (step === "sent") {
    return (
      <div className="login-widget login-widget--modal">
        <p>Kolla din e-post — vi har skickat en inloggningslänk.</p>
        <p>Kontrollera även din skräppostmapp.</p>
        <button className="login-btn" onClick={() => setStep("idle")}>
          Stäng
        </button>
      </div>
    );
  }

  return (
    <div className="login-widget login-widget--modal">
      <form onSubmit={handleRequest}>
        <label htmlFor="login-email">E-postadress</label>
        <input
          id="login-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="din@epost.se"
          required
          autoFocus
        />
        {error && <span className="login-error">{error}</span>}
        <div className="login-actions">
          <button type="submit" className="login-btn">
            Skicka länk
          </button>
          <button
            type="button"
            className="login-btn login-btn--ghost"
            onClick={() => setStep("idle")}
          >
            Avbryt
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginButton;
